import {defaultGhostBtn, ghostBtn} from '../btn-setup/btnTypeGhost';
import {subtleBtn} from '../btn-setup/btnTypeSubtle';
import {defaultLinkBtn, linkBtn} from '../btn-setup/btnTypeLink';
import {defaultBtn, regularBtn} from '../btn-setup/btnTypeRegular';
import {defaultRoundBtn, roundBtn} from '../btn-setup/btnTypeRound';

export const btnType = (color, round, ghost, link, subtle) => {
    // --- Condition Ghost --- //
    if (ghost) {
        if (color) {
            return ghostBtn({color});
        } else {
            return defaultGhostBtn();
        }
        // --- Condition Link --- //
    } else if (link) {
        if (color) {
            return `${linkBtn({color})}
            `;
        } else {
            return defaultLinkBtn();
        }
        // --- Condition subtle --- //
    } else if (subtle) {
        if (color) {
            return subtleBtn({color});
        }
        // --- Condition Round --- //
    } else if (round) {
        if (color) {
            return roundBtn({color});
        } else {
            return defaultRoundBtn();
        }
    } else {
        // --- Condition Regular (Default) --- //
        if (color) {
            return regularBtn({color});
        } else {
            return defaultBtn({color});
        }
    }
};

export const btnColorCondition = (color, ghost, link) => {
    // --- Condition Ghost --- //
    if (ghost) {
        if (color === 'default') {
            return `
                color: var(--btn-default) !important;
                border-color: var(--btn-default);
                --default: var(--btn-default);
                --default-dark: var(--btn-default-dark);
                &:hover {
                    color: var(--btn-default-dark);
                }
            `;
        } else return ``;
        // --- Condition Link --- //
    }
    if (link) {
        if (color === 'default') {
            return `
                color: var(--btn-default);!important;
                --default: var(--btn-default);
                --default-dark: var(--btn-default-dark);
                &:hover {
                    color: var(--btn-default-dark);
                }
            `;
        }
        // --- Condition Link --- //
    } else {
        // --- Condition Regular (Default) --- //
        if (color === 'default')
            return `
        color: var(--default-btn-text-color)!important;
        background: var(--btn-default);
        border-color: var(--btn-default);
        &:hover {
            color: var(--default-btn-text-color)!important;
            background: var(--btn-default-dark);
            border-color: var(--btn-default-dark);
        }
        `;
        else return ``;
    }
};
